import { Component, Input } from '@angular/core';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { ExpancionCard } from '../../shared/components-generals/expancion-card/expancion-card';
import { LocationDetailResponse } from '../../shared/models/location-model/location.model';
import { Product } from '../../shared/models/products-model/products.model';
import { TicketService } from '../../shared/services/ticket.service';
import { Ticket, TicketDetail, TicketSupply } from '../../shared/models/ticket-model/tiket.model';
import { GeneralService } from '../../shared/services/general.service';
import { MapGeneral } from '../../shared/components-generals/map-general/map-general';
import { MatDialog } from '@angular/material/dialog';
import { CdkAutofill } from '@angular/cdk/text-field';
import { AuthService } from '../../shared/services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { InputGeneralSelectComponent } from '../../shared/inputs/input-general-select/input-general-select.component';
import { FormControl } from '@angular/forms';
import { ProductsService } from '../../shared/services/products.service';
import { DeliveredModel } from '../delivered-model/delivered-model';

@Component({
  selector: 'app-profile-component',
  imports: [
    LoadGeneralComponent,
    NgClass,
    ExpancionCard,

    MatIconModule,
    InputGeneralSelectComponent,
  ],
  templateUrl: './profile-component.html',
  styleUrl: './profile-component.css',
})
export class ProfileComponent {
  @Input() locationDetail: LocationDetailResponse | null = null;
  @Input() productInCar: { [key: string]: Product } = {};
  @Input() locationDetailArray: LocationDetailResponse[] = [];

  private breakpointSubscription!: Subscription;
  public mobile = false;
  public openTicketDetail: TicketDetail | null = null;
  public ticketPendingSupply: TicketSupply[] | [] = [];
  public isLoading = true;
  public ticketInProcess = '';
  public address: FormControl = new FormControl();
  private inputSubscription!: Subscription;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private productsService: ProductsService,
    private generalService: GeneralService,
    private ticketService: TicketService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.checkScreenSize();
    this.getWorkFlowProject(this.locationDetail?.Id || null);
    this.address.setValue(this.locationDetail);
    this.inputSubscription = this.address.valueChanges.subscribe((value) => {
      localStorage.setItem('location', JSON.stringify(value));
      this.productsService.emitLocation.emit(value);
      this.getWorkFlowProject(value?.Id || null);
    });
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }
  }

  private checkScreenSize(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe((result) => {
        this.mobile = result.matches;
      });
  }

  public getproductInCarList(): Product[] {
    return Object.values(this.productInCar);
  }

  public getTotalAmount(): number {
    return Object.values(this.productInCar).reduce(
      (total, product) => total + (product.amount || 0),
      0,
    );
  }

  public getOpenTickets(params: {
    Page: number;
    PageSize: number;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
  }): void {
    this.ticketService.getOpenTickets(params).subscribe((response) => {
      const solicitudHelado = response?.Data.Items.find(
        (item: any) => item.WorkFlowType === 'Solicitud Helado',
      );
      if (!solicitudHelado) {
        this.openTicketDetail = null;
      } else {
        this.ticketService.getTicketDetail(solicitudHelado.Id).subscribe((response) => {
          this.openTicketDetail = response?.Data || null;
        });
        this.ticketService.ticketPendingSupply(solicitudHelado.Id).subscribe((response) => {
          this.ticketPendingSupply = response?.Data || [];
        });
      }
      this.isLoading = false;
    });
  }

  public getWorkFlowProject(locationId: number | null): void {
    this.isLoading = true;
    this.ticketService
      .getWorkFlowProject({ LocationId: locationId || 0, WorkFlowId: 16 })
      .subscribe((proyects) => {
        this.openTicketDetail = null;
        if (proyects?.Data?.length) {
          this.ticketInProcess = proyects?.Data[0].Key || '';
          this.getOpenTickets({
            Page: 1,
            PageSize: 10,
            SearchField: 'ODT',
            SearchFieldValue: proyects?.Data[0].Key,
          });
        } else {
          this.isLoading = false;
        }
      });
  }

  public openMap(): void {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 640px)');
    const dialogRef = this.dialog.open(MapGeneral, {
      width: isMobile ? '95vw' : '75vw',
      height: '95%',
      maxWidth: isMobile ? '90vw' : '75vw',
      maxHeight: isMobile ? '95vh' : '75vh',
      disableClose: true,
      autoFocus: false,
      data: this.openTicketDetail,
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  logout() {
    this.authService.logout();
  }

  public openCloseTicketDetail(): void {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 640px)');
    const dialogRef = this.dialog.open(DeliveredModel, {
      width: isMobile ? '95vw' : '75vw',
      height: '95%',
      maxWidth: isMobile ? '90vw' : '75vw',
      maxHeight: isMobile ? '95vh' : '75vh',
      disableClose: true,
      autoFocus: false,
      data: {
        ticketDetail: this.openTicketDetail,
        locationDetail: this.locationDetail,
        ticketInProcess: this.ticketInProcess,
      },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
}
